var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "gestion_svg__cls-1",
    d: "M128.13 88.62H65.88a6.5 6.5 0 100 13h62.25a6.5 6.5 0 000-13zM65.88 79.87H94a6.5 6.5 0 000-13H65.88a6.5 6.5 0 000 13zM128.13 110.38H65.88a6.5 6.5 0 100 13h62.25a6.5 6.5 0 000-13zM128.13 132.13H65.88a6.5 6.5 0 100 13h62.25a6.5 6.5 0 000-13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "gestion_svg__cls-1",
    d: "M160.51 45.74a6.53 6.53 0 00-1.85-3.74l-29.32-29.34a6.52 6.52 0 00-4.6-1.91H50.05a18.52 18.52 0 00-18.5 18.5v134.37a18.52 18.52 0 0018.5 18.5h92a18.52 18.52 0 0018.5-18.5v-117c.02-.24-.01-.62-.04-.88zm-15 1.51h-22V25.3zm-3.48 121.87h-92a5.51 5.51 0 01-5.5-5.5V29.25a5.51 5.51 0 015.5-5.5h60.54v30a6.5 6.5 0 006.5 6.5h30.48v103.37a5.5 5.5 0 01-5.48 5.5z"
  })));
}

export default SvgGestion;